module.exports = __webpack_public_path__ + "img/icon_video_play_big@2x.d04e594a.png";